import { $ } from 'utils/dom';
import Cookiebanner from 'modules/cookiebanner/cookiebanner';

const siteId = document.body.getAttribute('data-tracking-id');
const privacyPolicyLink =
  document.querySelector('[data-privacy-policy-link]') &&
  document.querySelector('[data-privacy-policy-link]').dataset
    .privacyPolicyLink;

const siteNoTracking = $('[data-no-tracking]');

if (siteNoTracking) {
  const matomoScript = document.getElementById('matomo');
  if (matomoScript) {
    matomoScript.remove();
  }

  function removeCookies(cookies) {
    for (let c = 0; c < cookies.length; c++) {
      const d = window.location.hostname.split('.');
      while (d.length > 0) {
        const cookieBase =
          encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
          '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
          d.join('.') +
          ' ;path=';
        // eslint-disable-next-line no-restricted-globals
        const p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        }
        d.shift();
      }
    }
  }

  const cookies = document.cookie.split('; ');
  if (cookies.length) {
    removeCookies(cookies);
  }
} else {
  if (siteId && privacyPolicyLink) {
    new Cookiebanner({
      cookieName: 'Helmholtz-Cookie',
      cookieDuration: 365,
      cookieTypes: [
        {
          name: {
            de: 'Optionale Cookies',
            en: 'Optionale Cookies',
          },
          text: {
            de: `Ohne Ihre Zustimmung setzen wir keine Cookies auf unserer Website ein. Ausschließlich nach Ihrer Zustimmung verarbeiten wir anonyme Daten, aus denen pseudonymisierte Nutzungsprofile erstellt und ausgewertet werden. Dazu nutzen wir die Webanalysedienst-Software Matomo. Hier können Sie den Cookie aktivieren oder deaktivieren. Sie können Ihre Einstellungen jederzeit ändern. <a href="${privacyPolicyLink}" class="link">Zur Datenschutzerklärung.</a>`,
            en: `We do not use cookies on our website without your consent. Only after your consent do we process anonymous data, from which pseudonymized user profiles are created and evaluated. For this purpose we use the web analysis service software Matomo. Here you can activate or deactivate the cookie. You can change your settings at any time. <a href="${privacyPolicyLink}" class="link">Our privacy policy.</a>`,
          },
          checkbox: {
            de: 'Tracking-Cookies aktivieren',
            en: 'Activate tracking cookies',
          },
          type: 'script',
          subType: 'matomo',
          trackingScripts: [
            {
              insertSelector: 'body',
              id: 'matomo',
              script:
                'var _paq = window._paq = window._paq || [];\n' +
                "_paq.push(['trackPageView']);\n" +
                "_paq.push(['enableLinkTracking']);\n" +
                '(function() {\n' +
                'var u="//piwik.helmholtz.de/";\n' +
                "_paq.push(['setTrackerUrl', u+'matomo.php']);\n" +
                `_paq.push(['setSiteId', '${siteId}']);\n` +
                "var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n" +
                "g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);\n" +
                '})();',
            },
          ],
        },
      ],
    }).init();
  }
}
